// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { labelStyles } from '@zapier/common-utils';

import Option from './Option'; // temporary import while we get it from ZDS

type OptionShape = {
  id: string,
  label: string,
};

type Props = {
  options: Array<OptionShape>,
  onChange?: () => {},
};

const Styles = labelStyles('Options', {
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridRowGap: 20,
    marginBottom: 0,
    paddingLeft: 0,
  },
  listItem: {
    listStyle: 'none',
  },
});

const Options = ({ options, onChange }: Props) => {
  return (
    <ul css={Styles.root}>
      {options.map(option => (
        <li css={Styles.listItem} key={option.id}>
          <Option
            id={option.id}
            key={option.id}
            label={option.label}
            onChange={onChange}
          />
        </li>
      ))}
    </ul>
  );
};

Options.defaultProps = {
  onChange: () => {},
};

export default Options;
